import { render } from "./loginModal.vue?vue&type=template&id=7633b348&scoped=true"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"

import "./loginModal.vue?vue&type=style&index=0&id=7633b348&scoped=true&lang=css"

import exportComponent from "/Applications/projects/bas-taj-korak-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7633b348"]])

export default __exports__